import NewBookingHotelList from "./NewBookingHotelList";

export default NewBookingHotelList;
